import { useContext, useState } from "react";
import shapes from "./../assets/shapes.png";
import { arrow, benefit1, circledTick } from "./../assets/icons";
import { featureBenefits, generalBenefits } from "../utils/static";
import { AppContext } from "../context/context";

function Benefits() {
  const { setState } = useContext(AppContext);

  const [benefits, setBenefits] = useState({
    one: false,
    two: false,
    three: false,
    four: false,
    five: false,
  });

  const handlebenefits = (button) => {
    const newbenefits = { one: false, two: false, three: false, four: false };
    newbenefits[button] = !benefits[button];
    setBenefits(newbenefits);
  };

  return (
    <div className="relative w-full h-fit flex flex-col items-center bg-gradient-to-b from-teal via-teal/60 to-white text-white">
      <img
        src={shapes}
        alt="shapes"
        className="absolute w-full"
        onLoad={() => {
          setState((ps) => ({ ...ps, loadedImages: ps.loadedImages + 1 }));
        }}
      />

      <div className="w-full h-fit z-10 flex flex-col justify-center items-center gap-6 pt-16 px-4 smd:px-8 md:px-16 lg:px-8 lxl:px-48">
        <div className="w-full flex flex-col items-center gap-6">
          <h6 className="text-center text-[28px] md:text-[40px] lg:text-[48px] font-bold leading-tight">
            Scale Your HR Management
          </h6>

          <p className="max-w-[600px] text-center text-sm smd:text-base md:text-lg text-white">
            From HR management to rostering, leave management to events, we
            offer all the benefits to help build a great organization.
          </p>
        </div>
      </div>

      <div className="w-full max-w-[1350px] z-[10] h-full grid grid-cols-1 lg:grid-cols-3 justify-center items-center gap-6 pt-16 px-8 md:px-16 lg:px-8">
        <div className="w-full lg:col-span-1 h-full p-4 smd:p-8 bg-purp hover:bg-teal rounded-2xl flex flex-wrap gap-1 duration-500">
          <div className="w-full flex flex-col mb-4">
            <div className="w-14 h-14 rounded-full bg-white/20 flex items-center justify-center">
              <span className="w-8">{benefit1}</span>
            </div>
            <h1 className="text-[22px] font-semibold my-4">
              Benefits That SynapsivateHRM Offers
            </h1>

            <h1>
              Dive into a transformative experience to explore the comprehensive
              benefits of SynapsivateHRM.
            </h1>
          </div>

          <>
            {generalBenefits.map((benefit, index) => (
              <div
                key={index}
                className="w-[300px] mt-2 flex items-center gap-2"
              >
                <span className="min-w-[16px] max-w-[16px]">{circledTick}</span>
                {benefit}
              </div>
            ))}
          </>
        </div>

        <div className="w-full lg:col-span-2 h-full grid grid-cols-1 md:grid-cols-2 gap-4 text-black">
          {featureBenefits.map((benefit, index) => (
            <div
              key={index}
              className={`${
                index === 4 && "col-span-1 md:col-span-2"
              } relative ${
                benefit.z
              } w-full bg-white hover:bg-teal group shadow-xl rounded-2xl flex flex-col p-4 smd:p-8 duration-500`}
            >
              <div
                className={`w-14 h-14 rounded-full ${benefit.iconColor} ${benefit.bgColor} flex items-center justify-center`}
              >
                <span className="w-7">{benefit.icon}</span>
              </div>

              <h1 className="text-xl font-bold mt-4 text-black group-hover:text-white duration-500">
                {benefit.name}
              </h1>
              <p className="text-gray-400 group-hover:text-white mt-1 duration-500">
                {benefit.description}
              </p>

              <button
                onClick={() => handlebenefits(benefit.number)}
                className="w-[100px] whitespace-nowrap flex justify-between items-center hover:scale-105 gap-2 mt-4 text-gray-500 group-hover:text-white/70 duration-500"
              >
                {benefits[benefit.number] ? "View less" : "View more"}
                {arrow(benefits[benefit.number])}
              </button>

              <div
                className={`absolute w-full flex flex-col px-4 smd:px-8 gap-4 text-black group-hover:text-white ${
                  benefits[benefit.number] ? "h-[293px] pt-4" : "h-0"
                } top-[94%] left-0 bg-white group-hover:bg-teal shadow-xl rounded-b-2xl overflow-hidden whitespace-nowrap duration-500`}
              >
                {benefit.more.map((more, index) => (
                  <p
                    key={index}
                    className="flex items-center whitespace-nowrap truncate gap-2"
                  >
                    <span className="min-w-[16px] max-w-[16px] pt-0.5">
                      {circledTick}
                    </span>
                    {more}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Benefits;
